import { Component, computed, input, TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

export interface StaticTable {
  headline?: string;
  entries: TableEntry[];
}

export interface TableEntry {
  title: string;
  content?: unknown;
  contentTemplate?: TemplateRef<unknown>;
  contentTemplateContext?: Record<string, unknown>;
  row?: number;
}

@Component({
  selector: 'comp-grid-table',
  templateUrl: 'grid-table.component.html',
  styleUrls: ['./grid-table.component.scss'],
  imports: [NgTemplateOutlet],
})
export class GridTableComponent {
  readonly columns = input<number>(1);
  readonly tableContent = input<StaticTable>();

  readonly headline = computed<string | undefined>(() => {
    return this.tableContent()?.headline;
  });

  readonly entries = computed<TableEntry[] | undefined>(() => {
    return this.tableContent()?.entries;
  });

  readonly entryRows = computed<TableEntry[][]>(() => {
    const rows = new Map<number, TableEntry[]>();

    for (const entry of this.entries() ?? []) {
      const row = entry.row ?? 0;
      rows.set(row, [...(rows.get(row) ?? []), entry]);
    }

    return [...rows.entries()].sort(([rowA], [rowB]) => rowA - rowB).map(([, entries]) => entries);
  });
}
